// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"6ff143f3aad4cf4fdd8a","695":"e73d1e91ca447366676c","2948":"1010430432936565454e","9462":"f8f99f3e8e2a4a6fb6f4"}[chunkId] + ".chunk.css";
};